import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { WishlistService } from '../../../services/raintree/Transmission/wishlist.service';
import { DpSuccessMessageComponent } from '../../../common-component/dp-success-message/dp-success-message.component';
import { loadavg } from 'node:os';
import { LoaderComponent } from '../../../common-component/loader/loader.component';

@Component({
  selector: 'app-delete-wishlist-dialog',
  standalone: true,
  imports: [MatDialogModule, LoaderComponent],
  templateUrl: './delete-wishlist-dialog.component.html',
  styleUrl: './delete-wishlist-dialog.component.scss',
})
export class DeleteWishlistDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DeleteWishlistDialogComponent>,
    private _wishlistService: WishlistService,
    private dialog: MatDialog,
    private toaster: ToastrService
  ) { }
  isLoading: boolean = false
  deleteWishlist() {
    this.isLoading = true
    if (this.data.type === 'centralizedReach' || this.data.type === 'Reach') {
      this._wishlistService.deleteReachWishList(this.data.id).subscribe({
        next: (response: any) => {
          if (!response.error)
            this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `Wishlist ${this.data.name} has been deleted`,
                subHeading:
                  'You can access all wish-lists from the ‘My wishlist’ menu on the Reach Defaulter page ',
                buttonValue: 'Done',
              },
            });
          this.isLoading = false
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.isLoading = false
          this.toaster.error(error);
        },
      });
    } else if (this.data.type === 'centralizedFd' || this.data.type === 'fd') {
      this._wishlistService
        .deletePHLWishList(this.data.id, { listType: 'PHL' })
        .subscribe({
          next: (response: any) => {
            if (!response.error)
              this.dialog.open(DpSuccessMessageComponent, {
                panelClass: 'common-pannel-dialog-container',
                data: {
                  mainHeading: `Wishlist ${this.data.name} has been deleted`,
                  subHeading:
                    'You can access all wish-lists from the ‘My wishlist’ menu on the Find Details page ',
                  buttonValue: 'Done',
                },
              });
            this.isLoading = false
            this.dialogRef.close(true);
          },
          error: (error) => {
            this.isLoading = false
            this.toaster.error(error);
          },
        });
    } else if (this.data.type === 'centralizedPm' || this.data.type === 'pm') {
      this._wishlistService
        .delWishlist({
          wishlistId: String(this.data.id),
          uiState: this.data.state,
          uiDistrict: this.data.district,
          pincode: this.data.pincode,
        })
        .subscribe({
          next: (response: any) => {
            console.log(response);
            if (!response.error)
              this.dialog.open(DpSuccessMessageComponent, {
                panelClass: 'common-pannel-dialog-container',
                data: {
                  mainHeading: `Wishlist ${this.data.name} has been deleted`,
                  subHeading:
                    'You can access all wish-lists from the ‘View wishlist’ menu on the Print and Monitor page ',
                  buttonValue: 'Done',
                },
              });
            this.isLoading = false
            this.dialogRef.close(true);
          },
          error: (error) => {
            this.isLoading = false
            this.toaster.error(error);
          },
        });
    }
  }
}
